import React, { useLayoutEffect, useRef, useState } from 'react';

type Props = {
  text: string;
};

/** 주간학습 준비물: 칸보다 길면 오른쪽→왼쪽으로 흐름 (대시보드 캘린더 행사명과 동일 방식) */
const WeeklyGuideMaterialMarquee: React.FC<Props> = ({ text }) => {
  const viewportRef = useRef<HTMLSpanElement | null>(null);
  const firstRef = useRef<HTMLSpanElement | null>(null);
  const [loop, setLoop] = useState(false);

  useLayoutEffect(() => {
    const vp = viewportRef.current;
    const first = firstRef.current;
    if (!vp || !first || !text) {
      setLoop(false);
      return;
    }
    const check = () => {
      setLoop(first.scrollWidth > vp.clientWidth + 1);
    };
    check();
    const ro = new ResizeObserver(check);
    ro.observe(vp);
    ro.observe(first);
    return () => ro.disconnect();
  }, [text]);

  const durationSec = Math.max(8, Math.min(40, text.length * 0.42));
  return (
    <span
      className={'cp-wlg-material-scroll' + (loop ? ' is-loop' : '')}
      title={text}
      style={loop ? ({ ['--cp-wlg-material-marquee-dur' as string]: `${durationSec}s` } as React.CSSProperties) : undefined}
    >
      <span ref={viewportRef} className="cp-wlg-material-clip">
        <span className="cp-wlg-material-track">
          <span ref={firstRef} className="cp-wlg-material-seg">
            {text}
            {loop ? <span className="cp-wlg-material-sep">{' · '}</span> : null}
          </span>
          {loop ? (
            <span className="cp-wlg-material-seg cp-wlg-material-seg--clone" aria-hidden>
              {text}
              <span className="cp-wlg-material-sep">{' · '}</span>
            </span>
          ) : null}
        </span>
      </span>
    </span>
  );
};

export default WeeklyGuideMaterialMarquee;
